import { render, staticRenderFns } from "./BiLayout.vue?vue&type=template&id=9e8bc574&scoped=true&"
import script from "./BiLayout.vue?vue&type=script&lang=js&"
export * from "./BiLayout.vue?vue&type=script&lang=js&"
import style0 from "./BiLayout.vue?vue&type=style&index=0&id=9e8bc574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8bc574",
  null
  
)

component.options.__file = "BiLayout.vue"
export default component.exports